import { useSelector } from 'react-redux'
import { Concept } from '../../../../../types/Survey/Analysis/Concept'
import useDidScroll from '../../../../UI/Layout/Header/useDidScroll'
import props from '../../../../../redux/props'

type Props = { activeConcept: Concept }

const ActiveConceptHeader: React.FC<Props> = ({ activeConcept }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const didScroll = useDidScroll()

  if (!activeConcept || !didScroll) return <></>
  return (
    <div
      className={`z-20 top-12 transition-all border-t border-lightGray bg-blue left-0 fixed w-full shadow-md flex flex-row items-center justify-between px-3`}
    >
      <div className="pl-6 py-2">
        <span className="uppercase text-white text-md">{t.survey.analysis.activeConceptHeader.titlePrefix}</span>
        <span className="text-white font-bold text-lg">{activeConcept.name}</span>
      </div>
    </div>
  )
}

export default ActiveConceptHeader
